import { AlipayCircleOutlined, CreditCardOutlined, WalletOutlined } from "@ant-design/icons";
import { ComponentType, CSSProperties, FC } from "react";

/**
 * ไอคอนของแต่ละช่องทางการชำระเงิน — ใช้ร่วมกันทั้งหน้าเลือกช่องทาง (CreditTopupPage.tsx) และคอลัมน์
 * "ประเภทการชำระเงิน" ในตาราง (CreditTopupListTable.tsx) กันไอคอนไม่ตรงกันระหว่าง 2 ที่
 *
 * 2026-09-09: promptpay ตอนนี้มีโลโก้แบรนด์จริงแล้ว (public/pp.svg) — render เป็น <img> แทน icon จาก
 * @ant-design/icons แยกออกจาก map ด้านล่าง (เช็ค type === "promptpay" ก่อนใน PaymentChannelIcon)
 * ช่องทางอื่นที่ยังไม่มีโลโก้แบรนด์จริง (TrueMoney) ยังใช้ไอคอนความหมายใกล้เคียงจาก @ant-design/icons
 * ไปก่อน — TrueMoney เป็น mobile wallet ใช้ไอคอนกระเป๋าเงิน ส่วน Alipay มีไอคอนแบรนด์จริงให้ใช้ได้เลย
 * (AlipayCircleOutlined)
 */
export const PAYMENT_CHANNEL_ICONS: Record<string, ComponentType<{ style?: CSSProperties }>> = {
  credit_card: CreditCardOutlined,
  truemoney: WalletOutlined,
  alipay: AlipayCircleOutlined,
};

/** ไอคอนสีเทากลาง — ใช้ตอนไม่รู้จัก payment_type (ไม่ควรเกิดขึ้นจริง แต่กันพังไว้) */
export const PaymentChannelIcon: FC<{ type: string | null | undefined; style?: CSSProperties }> = ({
  type,
  style,
}) => {
  if (type === "promptpay") {
    const size = style?.fontSize ?? 18;
    return (
      <img
        src="/pp.svg"
        alt="PromptPay"
        style={{ width: size, height: size, borderRadius: 4, display: "inline-block", verticalAlign: "middle" }}
      />
    );
  }
  const Icon = (type && PAYMENT_CHANNEL_ICONS[type]) || CreditCardOutlined;
  return <Icon style={style} />;
};
